import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@chapche/ui';
import { I18N_CODE_VALIDATION_ERROR } from '../../constant';

const RestrictedCodeInput = ({ itemCreateService }) => {
    const { i18n } = useTranslation();
    const [formCode, setFormCode] = useState('');
    const [error, setError] = useState('');

    const fillTheCode = (e) => {
        setFormCode(e.target.value);
        itemCreateService.changeItemCode(e.target.value);
        setError(itemCreateService.checkCodeValidation());
    };

    const changeInput = () => {
        setError(itemCreateService.checkCodeValidation());
    };

    useEffect(() => {
        itemCreateService.registerObserver(changeInput);
        return () => itemCreateService.unRegisterObserver(changeInput);
    }, []);

    return (
        <>
            <Input
                fullWidth
                value={formCode}
                onChange={fillTheCode}
                state={error ? 'error' : 'default'}
                errorText={error || undefined}
            />
            {!error ? (
                <p className="block__bullet alert__product">{i18n.t(I18N_CODE_VALIDATION_ERROR)}</p>
            ) : null}
        </>
    );
};

export default RestrictedCodeInput;
